import { render, staticRenderFns } from "./CreateOrganizationAdmins.vue?vue&type=template&id=11e85c50&scoped=true"
import script from "./CreateOrganizationAdmins.vue?vue&type=script&lang=ts&setup=true"
export * from "./CreateOrganizationAdmins.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./CreateOrganizationAdmins.vue?vue&type=style&index=0&id=11e85c50&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11e85c50",
  null
  
)

export default component.exports